import React from "react";

import Section from "./Component/sectio/Section";
// import Header from "./Component/Header";
// import Foot from "./Component/foot/Foot";
import Service from "./Component/service";
import Store from "./Component/store";
import { Route, Routes } from "react-router-dom";
import About from "./Component/about";
import Iphon from "./Component/iphon";
import Watch from "./Component/watch";
import Airpods from "./Component/airpods";
import Tv from "./Component/tv";
import Entertainment from "./Component/Entertainment";
import Accessories from "./Component/Accessories";
import Suport from "./Component/Suport";
import Vision from "./Component/vision";
import Four404 from "./Component/Four404";
import Share from "./Component/Share";

function App() {
  return (
    <div>
      
        {/* <Header/> */}
        <Routes>
          <Route path="/" element={<Share/>}>
          <Route path="/" element={<Section/>}/>
            <Route path="service" element={<Service/>}/>
       <Route path="store" element={<Store/>}/>
       <Route path="about" element={<About/>}/>
       <Route path="iphon" element={<Iphon/>}/>
       <Route path="watch" element={<Watch/>}/>
       <Route path="vision" element={<Vision/>}/>
       <Route path="Airpods" element={<Airpods/>}/>
       <Route path="Tv" element={<Tv/>}/>
       <Route path="Entertainment" element={<Entertainment/>}/>
       <Route path="Accessories" element={<Accessories/>}/>
       <Route path="Suport" element={<Suport/>}/>
       
          </Route>
          <Route path="*" element={<Four404/>}/>
       </Routes>
      
        {/* <Foot/> */}
     
    </div>  
    )
}

export default App;
